import { useEffect, useRef, useState } from "react";

export const useActiveElement = () => {
  /** Useful when working with autoFocus */

  const [activeElement, setActiveElement] = useState(document.activeElement);

  const ref = useRef(document.activeElement);
  useEffect(() => {
    const onFocus = (event) => {
      if (ref.current !== event.target) {
        setActiveElement(event.target);
        ref.current = event.target;
      }
    };

    // need the third argument as we want the bubbled event
    window.addEventListener("focus", onFocus, true);
    document.addEventListener("mousedown", onFocus);
    document.addEventListener("touchstart", onFocus);

    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("mousedown", onFocus);
      document.removeEventListener("touchstart", onFocus);
    };
  }, []);

  const output = // @ts-ignore
    activeElement === window ||
    // @ts-ignore
    activeElement === document
      ? null
      : activeElement;

  return output;
};
